import { Box } from '@mui/material';

import { Footer, Header } from 'src/components';

import ArtBackground from '../components/ArtBackground';

interface SupplierSignupLayoutProps {
  children: React.ReactNode;
}

export const SupplierSignupLayout = ({ children }: SupplierSignupLayoutProps) => (
  <Box minHeight="100vh" position="relative" overflow="hidden">
    <Header />
    <ArtBackground />

    {/* Main content */}
    <Box position="relative" zIndex={1}>
      {children}
    </Box>

    <Footer />
  </Box>
);
